import { SiteIdOverrideConfigList } from "stores/wizard/config";
import {
  siteId1,
  siteId3,
  siteId4,
  siteId4_fr_CA,
  siteId4_en_CA,
  siteId6,
  siteId6_en_GB,
  siteId8,
  siteId9,
  siteId11,
  siteId11_nl_NL,
  siteId11_en_GB,
  siteId12,
  siteId14,
  siteId15,
  siteId16,
  siteId17,
  siteId18,
  siteId6_de_DE,
  siteId20,
  siteId25,
  siteId27,
  siteId28,
  siteId29,
  siteId70201,
  siteId80001,
  siteId80004,
  siteId61,
  siteId62,
  siteId63,
  siteId64,
  siteId65,
  siteId66,
  siteId67,
  siteId68,
  siteId69,
  siteId70,
  siteId71,
  siteId72,
  siteId72_de_CH,
  siteId72_fr_CH,
  siteId72_en_GB,
  siteId73,
  siteId100388,
  siteId10122006,
  siteId10122006_de_DE,
  siteId10122006_en_GB,
  siteId1146,
  siteId1178,
  siteId4400,
  siteId4401,
  siteId4402,
  siteId4403,
  siteId4404,
  siteId4405,
  siteId4406,
  siteId4407,
  siteId70125,
  siteId70129,
  siteId70205,
  siteId70150,
  siteId70151,
  siteId70403,
  siteId70472,
  siteId70473,
  siteId70463,
  siteId70420,
  siteId70406,
  siteId70801,
  siteId705010001,
  siteId705010002,
  siteId705010003,
  siteId705010004,
  siteId705010005,
  siteId705010006,
  siteId705010008,
  siteId705010011,
  siteId705010012,
  siteId705010013,
  siteId705010014,
  siteId705010015,
  siteId705010016,
  siteId705010018,
  siteId705010019,
  siteId70901,
  siteId70903,
  siteId70904,
  siteId70906,
  siteId70908,
  siteId70909,
  siteId70911,
  siteId70912,
  siteId70914,
  siteId70915,
  siteId70916,
  siteId70917,
  siteId70918,
  siteId70920,
  siteId70925,
  siteId70927,
  siteId70928,
  siteId70929,
  siteId70961,
  siteId70962,
  siteId70963,
  siteId70964,
  siteId70965,
  siteId70966,
  siteId70967,
  siteId70968,
  siteId70969,
  siteId70970,
  siteId70971,
  siteId70972,
  siteId70973,
  siteId70975,
  siteId70472_de_CH,
  siteId70472_fr_CH,
  siteId70472_en_GB,
} from "stores/wizard/config/overrideConfigBySiteId/siteIds";
import { siteId70301 } from "./siteIds/siteId70301";
import { siteId100707 } from "./siteIds/siteId100707";

export const overrideConfigBySiteIdList: SiteIdOverrideConfigList = {
  1: {
    default: siteId1,
  },
  3: {
    default: siteId3,
  },
  4: {
    default: siteId4,
    fr_CA: siteId4_fr_CA,
    en_CA: siteId4_en_CA,
  },
  6: {
    default: siteId6,
    de_DE: siteId6_de_DE,
    en_GB: siteId6_en_GB,
  },
  8: {
    default: siteId8,
  },
  9: {
    default: siteId9,
  },
  11: {
    default: siteId11,
    nl_NL: siteId11_nl_NL,
    en_GB: siteId11_en_GB,
  },
  12: {
    default: siteId12,
  },
  14: {
    default: siteId14,
  },
  15: {
    default: siteId15,
  },
  16: {
    default: siteId16,
  },
  17: {
    default: siteId17,
  },
  18: {
    default: siteId18,
  },
  20: {
    default: siteId20,
  },
  25: {
    default: siteId25,
  },
  27: {
    default: siteId27,
  },
  28: {
    default: siteId28,
  },
  29: {
    default: siteId29,
  },
  61: {
    default: siteId61,
  },
  62: {
    default: siteId62,
  },
  63: {
    default: siteId63,
  },
  64: {
    default: siteId64,
  },
  65: {
    default: siteId65,
  },
  66: {
    default: siteId66,
  },
  67: {
    default: siteId67,
  },
  68: {
    default: siteId68,
  },
  69: {
    default: siteId69,
  },
  70: {
    default: siteId70,
  },
  71: {
    default: siteId71,
  },
  72: {
    default: siteId72,
    de_CH: siteId72_de_CH,
    fr_CH: siteId72_fr_CH,
    en_GB: siteId72_en_GB,
  },
  73: {
    default: siteId73,
  },
  70201: {
    default: siteId70201,
  },
  80001: {
    default: siteId80001,
  },
  80004: {
    default: siteId80004,
  },
  100707: {
    default: siteId100707,
  },
  100388: {
    default: siteId100388,
  },
  10122006: {
    default: siteId10122006,
    de_DE: siteId10122006_de_DE,
    en_GB: siteId10122006_en_GB,
  },
  1146: {
    default: siteId1146,
  },
  1178: {
    default: siteId1178,
  },
  4400: {
    default: siteId4400,
  },
  4401: {
    default: siteId4401,
  },
  4402: {
    default: siteId4402,
  },
  4403: {
    default: siteId4403,
  },
  4404: {
    default: siteId4404,
  },
  4405: {
    default: siteId4405,
  },
  4406: {
    default: siteId4406,
  },
  4407: {
    default: siteId4407,
  },
  70125: {
    default: siteId70125,
  },
  70129: {
    default: siteId70129,
  },
  70205: {
    default: siteId70205,
  },
  70150: {
    default: siteId70150,
  },
  70151: {
    default: siteId70151,
  },
  70301: {
    default: siteId70301,
  },
  70403: {
    default: siteId70403,
  },
  70473: {
    default: siteId70473,
  },
  70463: {
    default: siteId70463,
  },
  70420: {
    default: siteId70420,
  },
  70406: {
    default: siteId70406,
  },
  70801: {
    default: siteId70801,
  },
  705010001: {
    default: siteId705010001,
  },
  705010002: {
    default: siteId705010002,
  },
  705010003: {
    default: siteId705010003,
  },
  705010004: {
    default: siteId705010004,
  },
  705010005: {
    default: siteId705010005,
  },
  705010006: {
    default: siteId705010006,
  },
  705010008: {
    default: siteId705010008,
  },
  705010011: {
    default: siteId705010011,
  },
  705010012: {
    default: siteId705010012,
  },
  705010013: {
    default: siteId705010013,
  },
  705010014: {
    default: siteId705010014,
  },
  705010015: {
    default: siteId705010015,
  },
  705010016: {
    default: siteId705010016,
  },
  705010018: {
    default: siteId705010018,
  },
  705010019: {
    default: siteId705010019,
  },
  70901: {
    default: siteId70901,
  },
  70903: {
    default: siteId70903,
  },
  70904: {
    default: siteId70904,
  },
  70906: {
    default: siteId70906,
  },
  70908: {
    default: siteId70908,
  },
  70909: {
    default: siteId70909,
  },
  70911: {
    default: siteId70911,
  },
  70912: {
    default: siteId70912,
  },
  70914: {
    default: siteId70914,
  },
  70915: {
    default: siteId70915,
  },
  70916: {
    default: siteId70916,
  },
  70917: {
    default: siteId70917,
  },
  70918: {
    default: siteId70918,
  },
  70920: {
    default: siteId70920,
  },
  70925: {
    default: siteId70925,
  },
  70927: {
    default: siteId70927,
  },
  70928: {
    default: siteId70928,
  },
  70929: {
    default: siteId70929,
  },
  70961: {
    default: siteId70961,
  },
  70962: {
    default: siteId70962,
  },
  70963: {
    default: siteId70963,
  },
  70964: {
    default: siteId70964,
  },
  70965: {
    default: siteId70965,
  },
  70966: {
    default: siteId70966,
  },
  70967: {
    default: siteId70967,
  },
  70968: {
    default: siteId70968,
  },
  70969: {
    default: siteId70969,
  },
  70970: {
    default: siteId70970,
  },
  70971: {
    default: siteId70971,
  },
  70972: {
    default: siteId70972,
  },
  70973: {
    default: siteId70973,
  },
  70975: {
    default: siteId70975,
  },
  70472: {
    default: siteId70472,
    en_GB: siteId70472_en_GB,
    de_CH: siteId70472_de_CH,
    fr_CH: siteId70472_fr_CH,
  },
};
